export default function HarizonHelpCenter() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 233 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4740_49632)">
        <path
          d="M0 5C0 2.23858 2.23858 0 5 0H228C230.761 0 233 2.23858 233 5V115C233 117.761 230.761 120 228 120H5C2.23857 120 0 117.761 0 115V5Z"
          fill="url(#paint0_linear_4740_49632)"
        />
        <path
          d="M87.5698 87.0241C87.9443 87.1491 88.3308 87.2125 88.7186 87.2125H88.719C89.5565 87.2125 90.372 86.9107 91.0146 86.3652C92.4115 85.1792 93.0722 83.1709 92.0517 76.8274C91.1484 71.2028 89.7494 68.2571 87.3745 66.9794C86.8546 66.6992 86.3039 66.5123 85.7335 66.4223C85.7516 55.9388 89.344 46.2508 95.6133 39.8072C100.969 34.301 108.018 31.392 115.999 31.392C123.981 31.392 131.031 34.301 136.386 39.8072C142.656 46.2508 146.248 55.9371 146.266 66.4223C145.696 66.5123 145.145 66.6992 144.625 66.9794C142.25 68.2571 140.851 71.2028 139.948 76.8274C139.562 79.2294 139.403 81.0875 139.464 82.4971C137.617 83.4863 134.311 84.7122 128.815 85.1876C127.949 83.7447 126.405 82.8574 124.733 82.8574H121.562C118.926 82.8574 116.781 85.0024 116.781 87.6396C116.781 90.2768 118.926 92.4218 121.562 92.4218H124.733C126.599 92.4218 128.275 91.3493 129.061 89.6712C134.06 89.2559 138.186 88.2283 141.331 86.612C141.918 87.0056 142.588 87.2125 143.281 87.2125C143.672 87.2125 144.058 87.1491 144.43 87.0241C146.959 86.1817 152.293 80.417 152.637 67.97C152.99 55.2246 148.737 43.3365 140.968 35.3501C134.383 28.5795 125.748 25 116 25C106.251 25 97.6172 28.5795 91.0309 35.3501C83.2626 43.3367 79.0093 55.2246 79.3621 67.97C79.7063 80.417 85.0402 86.1817 87.5698 87.0241Z"
          fill="white"
        />
        <path
          d="M158.265 123.19C157.458 118.755 154.531 114.984 150.421 113.094L133.223 106.066C130.481 104.807 128.71 102.043 128.71 99.0252V97.639L128.256 97.7958C127.101 98.1963 125.916 98.398 124.733 98.398H121.562C115.63 98.398 110.804 93.5724 110.804 87.6393C110.804 81.7079 115.63 76.8821 121.562 76.8821H124.733C126.947 76.8821 129.074 77.5543 130.884 78.8271L130.998 78.9072L131.136 78.8838C134.922 78.2599 136.667 77.269 137.327 76.7871L138.458 75.1341C139.565 71.5761 140.127 68.235 140.127 65.2042C140.127 49.1561 129.98 37.5083 115.999 37.5083C102.019 37.5083 91.8727 49.1563 91.8727 65.2042C91.8727 78.4833 102.658 93.0287 102.717 93.0804C103.097 94.183 103.289 95.3322 103.289 96.4932V99.0254C103.289 102.043 101.517 104.805 98.7891 106.06L81.5651 113.1C77.4668 114.984 74.5389 118.757 73.7296 123.225L72.8169 135H159.183L158.265 123.19Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4740_49632"
          x1="0"
          y1="0"
          x2="383"
          y2="247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9C00" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_4740_49632">
          <path
            d="M0 5C0 2.23858 2.23858 0 5 0H228C230.761 0 233 2.23858 233 5V115C233 117.761 230.761 120 228 120H5C2.23857 120 0 117.761 0 115V5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
